
import Vue from "vue";
import Component from "vue-class-component";
import {
  acceptedState,
  authModule,
  challengeModule,
  challengesState,
  followedState,
  i18nModule,
  teamsState,
  userModule
} from "@/utils/store-acessor";
import NavBar from "@/components/NavBar";
import SubscribeButton from "@/components/Shared/SubscribeButton.vue";
import Footer from "@/components/Footer.vue";
import NotFound from "@/components/NotFound.vue";
import ChallengeRelatedChallenges from "./ChallengeRelatedChallenges.vue";
import ChallengeHeader from "./ChallengeHeader.vue";
import ChallengeToolbar from "./ChallengeToolbar.vue";
import ChallengeCountdown from "@/components/Challenges/ChallengeCountdown.vue";
import ChallengeActions from "@/components/Challenges/ChallengeActions.vue";
import ConfirmDialog from "@/components/Shared/ConfirmDialog.vue";
import { TeamModel } from "@/models/team.model";
import { ChallengeModel } from "@/models/challenge.model";
import { UserModel } from "@/models/user.model";
import moment from "moment-timezone";
import { Watch } from "vue-property-decorator";
import { Route } from "vue-router";
import $ from "jquery";
import { nFormatter } from "@/utils/utils";
import { LocaleSelectorType } from "@/store/i18n.store.module";
import { ScrollEvent } from "@/models/scroll-event";
import { ChallengeTeamsApi } from "@/api/challenge-teams.api";

interface ChallengeTab {
  router: { name?: string; path?: string };
  title: string;
  key: ChallengeTabKeyTypes;
  count: number;
  ruleToShow: boolean;
}

export type ChallengeTabKeyTypes =
  | "tab-description"
  | "tab-timeline"
  | "tab-task"
  | "tab-teams"
  | "tab-community"
  | "tab-forum"
  | "tab-my-team"
  | "tab-faqs"
  | "tab-judges"
  | "tab-advisers"
  | "tab-partners"
  | "tab-map"
  | "tab-gallery"
  | "tab-files";

@Component({
  components: {
    ConfirmDialog,
    NavBar,
    SubscribeButton,
    Footer,
    NotFound,
    ChallengeRelatedChallenges,
    ChallengeHeader,
    ChallengeToolbar,
    ChallengeCountdown,
    ChallengeActions
  },
  metaInfo() {
    // @ts-ignore
    const hasTranslate = !!this.challenge?.title?.pt;
    // @ts-ignore
    let title = this.challenge?.title;
    if (hasTranslate) {
      // @ts-ignore
      if (this.locale?.value == "ptBr") {
        // @ts-ignore
        title = this.challenge?.title?.pt;
      } else {
        // @ts-ignore
        title = this.challenge?.title?.en;
      }
    }
    return {
      title: title ? `${title} - Ikone` : "Ikone"
    };
  }
})
export default class ChallengeDetails extends Vue {
  isActionsDisabled: boolean = false;
  @challengeModule.Getter("selectedChallenge")
  readonly challenge!: ChallengeModel | null;
  @challengeModule.Getter("loading") readonly loading!: boolean;
  @authModule.Getter("isAuthenticated") readonly isAuthenticated!: boolean;
  @userModule.Getter("canAcceptChallenges") canAccept!: boolean;
  @userModule.Action("fetchUser") fetchUser: any;
  @userModule.Getter("user") user!: UserModel;
  @userModule.Getter("timezone") timezone!: string;
  @i18nModule.Getter("locale") locale!: LocaleSelectorType;

  myTeam: TeamModel | null = null;
  tab = null;
  error: any = null;
  showExtension = false;
  tabs: ChallengeTab[] = [
    {
      router: { name: "challenge-description" },
      title: "challenge.description",
      key: "tab-description",
      count: 0,
      ruleToShow: true
    },
    {
      router: { name: "challenge-timeline" },
      title: "challenge.tab_titles.timeline",
      key: "tab-timeline",
      count: 0,
      ruleToShow: true
    },
    {
      router: { name: "challenge-tasks" },
      title: "challenge.tab_titles.tasks",
      key: "tab-task",
      count: 0,
      ruleToShow: true
    },
    {
      router: { name: "challenge-community" },
      title: "challenge.tab_titles.community",
      key: "tab-community",
      count: 0,
      ruleToShow: true
    },
    {
      router: { name: "challenge-forum" },
      title: "forum.title",
      key: "tab-forum",
      count: 0,
      ruleToShow: true
    },
    {
      router: { name: "challenge-teams" },
      title: "challenge.tab_titles.teams",
      key: "tab-teams",
      count: 0,
      ruleToShow: true
    },
    {
      router: { name: "challenge-team-members" },
      title: "challenge.tab_titles.my_team",
      key: "tab-my-team",
      count: 0,
      ruleToShow: true
    },
    {
      router: { name: "challenge-faqs" },
      title: "challenge.tab_titles.faq",
      key: "tab-faqs",
      count: 0,
      ruleToShow: false
    },
    {
      router: { name: "challenge-judges" },
      title: "challenge.tab_titles.judges",
      key: "tab-judges",
      count: 0,
      ruleToShow: false
    },
    {
      router: { name: "challenge-advisers" },
      title: "challenge.tab_titles.advisers",
      key: "tab-advisers",
      count: 0,
      ruleToShow: false
    },
    {
      router: { name: "challenge-partners" },
      title: "challenge.tab_titles.partners",
      key: "tab-partners",
      count: 0,
      ruleToShow: true
    },
    {
      router: { name: "challenge-map" },
      title: "challenge.tab_titles.map",
      key: "tab-map",
      count: 0,
      ruleToShow: true
    },
    {
      router: { name: "challenge-gallery" },
      title: "challenge.tab_titles.gallery",
      key: "tab-gallery",
      count: 0,
      ruleToShow: true
    },
    {
      router: { name: "challenge-files" },
      title: "challenge.tab_titles.files",
      key: "tab-files",
      count: 0,
      ruleToShow: true
    }
  ];
  challengeDeadlineHumanized = "";
  challengeDeadline = "";
  registrationDeadlineHumanized = "";
  registrationDeadline = "";

  formatCounter(value: number) {
    return nFormatter(value);
  }

  get registrationIsPossible(): boolean {
    if (!this.challenge?.registration_deadline) {
      return true;
    }
    if (this.challenge?.registration_deadline == "finished") {
      return false;
    }
    return moment(this.challenge.registration_deadline)
      .tz(this.timezone)
      .isAfter(moment());
  }

  @Watch("locale", { immediate: true, deep: true })
  onLocaleChange(locale: LocaleSelectorType) {
    this.changeCounterLocale();
  }

  updateState(element: ScrollEvent) {
    this.showExtension = element?.challengeDetailTabs?.isAboveViewport;
  }

  private changeCounterLocale() {
    if (this.challenge?.deadline) {
      this.challengeDeadlineHumanized = moment(this.challenge.deadline)
        .tz(this.timezone)
        .fromNow();
      this.challengeDeadline = this.$t("challenge.ending_in", [this.challengeDeadlineHumanized]).toString();
    }
    if (this.challenge?.registration_deadline != "finished" && this.challenge?.registration_deadline != null) {
      this.registrationDeadlineHumanized = moment(this.challenge.registration_deadline)
        .tz(this.timezone)
        .fromNow();
      this.registrationDeadline = this.$t("challenge.registration_end", [
        this.registrationDeadlineHumanized
      ]).toString();
    }
  }

  async mounted() {
    if (this.user?.id && this.canAccept) {
      acceptedState.fetchAcceptedChallenges({
        params: {
          page: 1
        }
      });
    }
    if (this.user?.slug) {
      followedState.fetchfollowedChallenges(this.user.slug);
    }

    this.scrollTabs();
  }

  @Watch("canAccept", { deep: true, immediate: true })
  listenCanAccept(v: boolean) {
    if (v && this.user?.contestant?.id && this.user?.slug) {
      acceptedState.fetchAcceptedChallenges({
        params: {
          page: 1
        }
      });
      if (this.challenge?.id && this.user?.contestant?.id) {
        teamsState.fetchMyTeam(this.challenge.id, this.user?.contestant?.id).then((myTeam: TeamModel | null) => {
          this.myTeam = myTeam;
        });
      }
    }
  }

  @Watch("challenge", { deep: true, immediate: true })
  onChallengeChange(challenge: ChallengeModel) {
    const isUserValid = this.user?.contestant?.id && this.user?.slug && this.user?.user_profile;
    if (challenge?.id && isUserValid && !this.myTeam) {
      if (this.user?.contestant?.id) {
        teamsState.fetchMyTeam(challenge.id, this.user?.contestant?.id).then((myTeam: TeamModel | null) => {
          this.myTeam = myTeam;
        });
      }
    }
    this.changeCounterLocale();
  }

  tabActive(tab: ChallengeTab) {
    if (tab.router?.name && this.$route.name) {
      return this.$route.name === tab.router?.name ? "tab-active" : "tab-initial";
    }
  }

  onCountdownFinish() {
    this.isActionsDisabled = true;
  }

  @Watch("$route", { immediate: true, deep: true })
  onWatchRoute(value: Route) {
    const slug = value.params.slug;
    if (slug) {
      challengesState.getChallengeBySlug({ slug });
    }
  }

  scrollTabs() {
    $(window).on("scroll", function() {
      let scroll = $(this).scrollTop() ?? 0;
      if (scroll >= 550) {
        $(".challenge-tabs").addClass("scroll-tabs");
      } else {
        $(".challenge-tabs").removeClass("scroll-tabs");
      }
    });
  }

  showTab(tab: ChallengeTab, myTeam?: TeamModel): boolean {
    const hasSettings = !!this.challenge?.settings;
    switch (tab.key) {
      case "tab-community":
        tab.count = this.challenge?.contestants_count || 0;
        return hasSettings ? !!this.challenge?.settings?.tabs?.comunity : true;
      case "tab-timeline":
        return hasSettings ? !!this.challenge?.settings?.tabs?.timeline : true;
      case "tab-forum":
        return hasSettings ? !!this.challenge?.settings?.tabs?.forum : true;
      case "tab-files":
        tab.count = this.challenge?.files_count || 0;
        return tab.count > 0 && (hasSettings ? !!this.challenge?.settings?.tabs?.files : true);
      case "tab-gallery":
        tab.count = this.challenge?.galery_count || 0;
        return tab.count > 0;
      case "tab-task":
        tab.count = this.challenge?.tasks_count || 0;
        return tab.count > 0;
      case "tab-teams":
        tab.count = this.challenge?.teams_count || 0;
        return !!this.challenge?.teams_enabled && tab.count > 0;
      case "tab-my-team":
        return !!myTeam;
      case "tab-judges":
        tab.count = this.challenge?.judges_count || 0;
        return tab.count > 0;
      case "tab-partners":
        tab.count = this.challenge?.partners_count || 0;
        return tab.count > 0 && (hasSettings ? !!this.challenge?.settings?.tabs?.partners : true);
      case "tab-advisers":
        tab.count = this.challenge?.advisors_count || 0;
        return tab.count > 0;
      case "tab-faqs":
        tab.count = this.challenge?.faqs_count || 0;
        return tab.count > 0;
      case "tab-map":
        return hasSettings ? !!this.challenge?.settings?.tabs?.map : true;
      default:
        return tab.ruleToShow;
    }
  }
}
